import { createTheme } from "@mui/material/styles"

export const Colors = {
    primary: "#aa00ff",
    primary_light: "#e254ff",
    primary_dark: '#7200ca',
    secondary: "#448aff",
    secondary_light: "#83b9ff",
    secondary_dark: "#005ecb",
    success: "#4CAF50",
    info: "#00a2ff",
    danger: "#FF5722",
    warning: "#FFC107",
    dark: "#0e1b20",
    light: "#aaa",
    muted: "#abafb3",
    border: "#DDDFE1",
    inverse: "#2F3D4A",
    shaft: "#333",
    dove_gray: "#d5d5d5",
    body_bg: "#f3f6f9",
    ///////////////
    // Solid Color
    ///////////////
    white: "#fff",
    black: "#000",
    bitcoin: "#ffb721",
    ethereum: "#14f1c1",
    ripple: "#336efc",
    blackcoin: "#d4a552",
  }


  const theme = createTheme({
        palette:{
            primary:{
                main:Colors.primary
            },
            secondary:{
                main:Colors.secondary
            },
            white:{
                main:Colors.white
            }
        },
        components:{
            MuiButton:{
                defaultProps:{
                    disableRipple:false,
                    disableElevation:false
                }
            },
            MuiChip:{
                styleOverrides:{
                    root:{
                        fontWeight:350,
                    }
                }
            }
        }
  })

  export default theme